import { createContext, __DEV__ } from '../../utils';
import * as React from 'react';
import { useCheckboxGroup } from './use-checkbox-group';
var [CheckboxGroupProvider, useCheckboxGroupContext] = createContext({
  name: 'CheckboxGroupContext',
  strict: false
});
export { useCheckboxGroupContext };

/**
 * Used for multiple checkboxes which are bound in one group,
 * and it indicates whether one or more options are selected.
 */
export var CheckboxGroup = props => {
  var {
    colorScheme,
    size,
    variant,
    children
  } = props;
  var {
    value,
    onChange
  } = useCheckboxGroup(props);
  var group = React.useMemo(() => ({
    size,
    onChange,
    colorScheme,
    value,
    variant
  }), [size, onChange, colorScheme, value, variant]);
  return /*#__PURE__*/React.createElement(CheckboxGroupProvider, {
    value: group
  }, children);
};
if (__DEV__) {
  CheckboxGroup.displayName = 'CheckboxGroup';
}